<template>
  <md-card>
    <md-card-content>
      <div class="md-layout md-gutter md-alignment-center-space-between">
        <div class="field-wrapper md-layout-item md-size-50">
          <div class="outlined-field">
            <md-field>
              <label>División</label>
              <md-select :disabled="loading" v-model="value.division">
                <md-option
                  v-for="division in catalogs.divisions"
                  :key="division.id"
                  :value="division.id"
                >
                  {{ division.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <md-button
            class="md-simple md-just-icon md-round button-delete"
            @click="() => (value.division = null)"
          >
            <md-icon>close</md-icon>
          </md-button>
        </div>
        <div
          v-show="value.division"
          class="md-layout-item md-layout md-alignment-center-right"
        >
          <md-button
            @click="$emit('editDivision')"
            class="md-just-icon md-round"
            :class="[editMode ? 'md-info' : 'md-warning']"
            style="margin-right: 18px"
          >
            <md-icon> {{ editMode ? "save" : "edit" }} </md-icon>
          </md-button>
          <md-button
            @click="$emit('deleteDivision')"
            class="md-danger md-just-icon md-round"
          >
            <md-icon> delete </md-icon>
          </md-button>
        </div>
        <!-- <div class="md-layout-item md-size-33">
          <div class="outlined-field">
            <md-field>
              <label>Estatus</label>
              <md-select :disabled="loading" v-model="filteredData.status">
                <md-option
                  v-for="camp in sinisterStatus"
                  :key="camp.id"
                  :value="camp.slug"
                  >{{ camp.name }}</md-option
                >
              </md-select>
            </md-field>
          </div>
        </div> -->
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "Filters",
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    catalogs: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    editMode: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.field-wrapper {
  position: relative;
  .button-delete {
    position: absolute;
    right: 60px;
    top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Divisions/Filters.vue